<template>
  <div id="rawfileChartModal">
    <div id="Loader" v-if="LoadYn">
      <div class="spinner-bar">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <!-- <div class="w-100 h-100 mx20">
      <div id="rawfileChart1" class="wc-sub40 h500"></div>
    </div> -->
    <div v-if="showGnss">
      <gnss-rawfile-chart-modal
        :chartData="gnssRawfileData"
      ></gnss-rawfile-chart-modal>
    </div>
    <div
      v-show="!showGnss"
      class="h-100"
      style="overflow-y: auto; max-height: 600px; min-height: 400px"
    >
      <div v-for="(c, i) in ch" v-bind:key="i" class="w-100 h330 px20">
        <!-- <span v-show="c !== '-'">Channel: {{ Number(c) + 1 }}</span> -->
        <span v-show="c !== '-'">{{ chartTitle(Number(c)) }}</span>
        <div :id="'rawfileChartNo' + c" class="w-100 h300"></div>
      </div>
    </div>
    <div class="btnGrp">
      <div class="jcfe">
        <b-button
          class="empty-delBtn"
          style="margin: 0px 20px"
          @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import GnssRawfileChartModal from "./GnssRawfileChartModal.vue";
import chartUtil from "../common/chartUtil";
import utils from "../common/utils";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    GnssRawfileChartModal,
  },
  computed: {
    ...mapGetters(["getCenterBus", "getAlertOptions"]),
  },
  props: {
    chartInfo: {
      type: Object,
    },
  },
  data() {
    return {
      LoadYn: false,
      ch: [],
      showGnss: false,
      gnssRawfileData: null,
    };
  },
  setup() {},
  created() {},
  mounted() {
    this.LoadYn = true;
    this.getData();
  },
  unmounted() {},
  methods: {
    ...mapMutations(["setAlertTitle"]),
    chartTitle(index) {
      let deviceType = this.chartInfo.filename.split("_")[1];
      if (utils.isKalman(deviceType)) {
        if (index === 0) {
          return "가속도 X축";
        } else if (index === 1) {
          return "가속도 Y축";
        } else if (index === 2) {
          return "가속도 Z축";
        } else if (index === 3) {
          return "GNSS";
        } else if (index === 4) {
          return "변위";
        } else if (index === 5) {
          return "속도";
        }
      } else {
        return "Channel: " + (index + 1).toString();
      }
    },
    getData() {
      let reqBody = {
        device_id: this.chartInfo.dev_id,
        file_name: this.chartInfo.filename,
      };
      this.$http
        .post("/sensor/getRawFileData", reqBody, { timeout: 600000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.LoadYn = false;
            let channels = res.data.data;
            let devicetype = this.chartInfo.filename.split("_")[1];
            if (utils.isGNSS(devicetype)) {
              this.gnssRawfileData = channels[0].data;
              this.showGnss = true;
            }
            for (let i = 0; i < channels.length; i++) {
              let filepath = channels[i].csv_file_path;
              let channel = "-";
              let pathSplit = filepath.split("_");
              if (pathSplit.length >= 5) {
                channel = pathSplit[pathSplit.length - 2];
                this.ch.push(channel.toString());
              } else {
                this.ch.push("-");
              }
              this.ch.sort();
              let data = channels[i].data;
              let chartData = { x: [], y: [] };
              if (data[0].length <= 4) {
                for (let i = 0; i < data.length; i++) {
                  chartData.x.push(data[i][data[i].length - 2]);
                  chartData.y.push(data[i][data[i].length - 1]);
                }
              } else {
                chartData.y1 = [];
                chartData.y2 = [];
                for (let i = 0; i < data.length; i++) {
                  chartData.x.push(data[i][1]);
                  chartData.y.push(data[i][2]);
                  chartData.y1.push(data[i][3]);
                  chartData.y2.push(data[i][4]);
                }
              }
              this.$nextTick(() => {
                let chartOption = {
                  x: chartData.x,
                  y: chartData.y,
                  name: "rawfile",
                };
                if (chartData.hasOwnProperty("y1") && chartData.y1) {
                  chartOption.y1 = chartData.y1;
                  chartOption.y2 = chartData.y2;
                }
                this.drawTimeLineChart(
                  "rawfileChartNo" + channel.toString(),
                  chartOption
                );
              });
            }
          } else {
            this.LoadYn = false;
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(res.data.errormsg, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    drawTimeLineChart(id, options, range) {
      let data = [
        {
          x: options.x,
          y: options.y,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
      ];
      if (options.hasOwnProperty("y1")) {
        data.push({
          x: options.x,
          y: options.y1,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
          name: "y축",
        });
        data.push({
          x: options.x,
          y: options.y2,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
          name: "z축",
        });
        data[0].name = "x축";
      }
      let layout = chartUtil.setTimeLayout(id, {
        margin: {
          l: 50,
          r: 30,
          t: 30,
          b: 50,
          pad: 10,
        },
        annotation: options.annotation,
        showlegend: false,
      });
      layout.xaxis.nticks = 6;
      Plotly.newPlot(id, data, layout);
    },
    closeModal() {
      this.$bvModal.hide("rawfileChartModal");
    },
  },
};
</script>
<style lang="scss">
#rawfileChartModal .modal-dialog {
  max-width: 1200px;
  padding: 15px;
  // .row {
  //   margin: 15px;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/RawfileChartModal.vue